import { useRef, useState } from 'react'
import { buildDragGhost } from '../../../helpers/pairings'

// Row reorders and golfer moves share one tree; a ref tells them apart, as dragOver beats React's render.

export const usePairingsDnD = () => {
  const [ rowDragIndex, setRowDragIndex ] = useState(null)
  const [ rowDragOverIndex, setRowDragOverIndex ] = useState(null)
  const [ playerDragSource, setPlayerDragSource ] = useState(null)
  const [ playerDragOverTarget, setPlayerDragOverTarget ] = useState(null)
  const draggingPlayerRef = useRef(false)

  const isDraggingPlayer = () => draggingPlayerRef.current

  const clearPlayerDrag = () => {
    draggingPlayerRef.current = false
    setPlayerDragSource(null)
    setPlayerDragOverTarget(null)
  }

  const clearRowDrag = () => {
    setRowDragIndex(null)
    setRowDragOverIndex(null)
  }

  // Starts a golfer drag and hands the browser a legible drag image.
  const startPlayerDrag = (event, { source, name, initials, handicapIndex }) => {
    event.stopPropagation()
    event.dataTransfer.effectAllowed = 'move'
    draggingPlayerRef.current = true
    setPlayerDragSource(source)
    const ghost = buildDragGhost(name, handicapIndex, initials)
    document.body.appendChild(ghost)
    event.dataTransfer.setDragImage(ghost, 20, 22)
    requestAnimationFrame(() => document.body.removeChild(ghost))
  }

  const markPlayerDragOver = (foursomeId, slotIndex) => {
    if (playerDragOverTarget?.foursomeId !== foursomeId || playerDragOverTarget?.slotIndex !== slotIndex) {
      setPlayerDragOverTarget({ foursomeId, slotIndex })
    }
  }

  const isPlayerDragOver = (foursomeId, slotIndex) =>
    playerDragOverTarget?.foursomeId === foursomeId && playerDragOverTarget?.slotIndex === slotIndex

  const isBeingDragged = (playerRoundId) => playerDragSource?.playerRoundId === playerRoundId

  return {
    rowDragIndex,
    setRowDragIndex,
    rowDragOverIndex,
    setRowDragOverIndex,
    playerDragSource,
    setPlayerDragOverTarget,
    isDraggingPlayer,
    startPlayerDrag,
    markPlayerDragOver,
    isPlayerDragOver,
    isBeingDragged,
    clearPlayerDrag,
    clearRowDrag,
  }
}
